var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTruck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.32 2.49a.852.852 0 0 0-.696-.364H8.506V.851A.852.852 0 0 0 7.656 0H.85A.852.852 0 0 0 0 .85v8.72h1.411a1.807 1.807 0 0 0 3.557 0H7.79a1.807 1.807 0 0 0 3.558 0h1.41V4.744c.001-.13-.04-.258-.114-.366L11.32 2.49ZM.85.85h6.805V5.53H.851V.85Zm2.34 9.357a.957.957 0 1 1 0-1.914.957.957 0 0 1 0 1.914Zm6.38 0a.957.957 0 1 1 0-1.915.957.957 0 0 1 0 1.915Zm2.338-1.488h-.611a1.807 1.807 0 0 0-3.455 0H4.917a1.807 1.807 0 0 0-3.455 0H.851v-2.34h11.057v2.34Zm0-3.19H8.506V2.977h2.118l1.284 1.835v.717Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTruck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "truck.d50a24937bc385cc651d1f5c27edbb7b.svg";